import { render, staticRenderFns } from "./BaseUploadDraggerList.vue?vue&type=template&id=5cb8a799&scoped=true&"
import script from "./BaseUploadDraggerList.vue?vue&type=script&lang=js&"
export * from "./BaseUploadDraggerList.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadDraggerList.vue?vue&type=style&index=0&id=5cb8a799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8a799",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb8a799')) {
      api.createRecord('5cb8a799', component.options)
    } else {
      api.reload('5cb8a799', component.options)
    }
    module.hot.accept("./BaseUploadDraggerList.vue?vue&type=template&id=5cb8a799&scoped=true&", function () {
      api.rerender('5cb8a799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseUploadDraggerList.vue"
export default component.exports